module.exports = __webpack_public_path__ + "static/images/exercise-bikes.f310af54ef7612202160aa46060e9d32.svg";